<template>
  <div>
    <FormWizardStepHeader
      title="Business model(s) you invest in"
      description="Select one or more business models you invest in"
    />

    <AlertSlideUpDown :show="$v.markets.$error"
      >Please select at least one market</AlertSlideUpDown
    >

    <FormItem>
      <b-form-checkbox-group
        v-model="form.markets"
        buttons
        class="btn-group-outline-spaced-big mb-20"
        @input="$v.markets.$touch()"
      >
        <b-form-checkbox
          v-for="market in markets"
          :key="market.value"
          :value="market.value"
        >
          <span>{{ getMarketLabel(market) }}</span>
        </b-form-checkbox>
      </b-form-checkbox-group>
    </FormItem>
  </div>
</template>

<script>
import FormItem from '@/components/form/FormItem'
import FormWizardStepHeader from '@/components/FormWizardStepHeader'
import AlertSlideUpDown from '@/components/AlertSlideUpDown'

export default {
  name: 'InvestorFormStepMarket',
  components: {
    AlertSlideUpDown,
    FormItem,
    FormWizardStepHeader
  },
  props: {
    $v: {
      type: Object,
      required: true
    },
    value: {
      type: Object
    }
  },
  data() {
    return {
      form: {
        ...this.value
      }
    }
  },
  computed: {
    markets() {
      return this.$store.getters['meta/investorMarkets']
    }
  },
  watch: {
    value(newValue) {
      this.form = newValue
    },
    form: {
      deep: true,
      handler() {
        this.$emit('input', this.form)
      }
    }
  },
  methods: {
    getMarketLabel(market) {
      switch (market.value) {
        case 'consumer':
          return 'B2C'
        case 'companies':
          return 'B2B'
        case 'marketplace':
          return 'Marketplace'
        case 'government':
          return 'B2G'

        default:
          return market.label
      }
    }
  }
}
</script>
